const _constant = {};
const decodeURIwindow = () => {
  if (typeof window !== "undefined") {
    return window.decodeURIComponent("%E2%80%99");
  }
  return "";
};

_constant.USER_AGENT_MOBILE = "MOBILE";
_constant.USER_AGENT_WEB = "WEB";
_constant.INPUT_TEXT_REGEX = /<(.|\n)*?>/g;
_constant.MOBILE_REG_EX = /[6789]{1}[0-9]*/;
_constant.NUMBER_REG_EX = /[^0-9]/g;
_constant.ADD_DESC_REGEX = new RegExp(`^([a-zA-Z0-9-'${decodeURIwindow()} ’& ]){3,30}$`);
_constant.MID = "MID";
_constant.TOKEN = "TOKEN";
_constant.UNIQUEID = "UNIQUEID";
_constant.OTP_MAX_RESEND = 5;
_constant.H_ORIENTATION = "H";
_constant.V_ORIENTATION = "V";
_constant.DATE_ORDINAL = "/";
_constant.PAYTM_BUSINESS_LINK_URL = "https://business.paytm.com/payment-link";
_constant.PAYTM_BUSINESS_INVOICE_URL = "https://paytm.business/invoices";
_constant.MOBILE_NUMBER = "MOBILENUMBER";
_constant.EMAIL_ID = "EMAILID";
_constant.DOB = "DOB";
_constant.DELIVERY_ADDRESS = "DELIVERYADDRESS";
_constant.GENDER = "GENDER";
_constant.FULL_NAME = "FULLNAME";
_constant.REGISTERED_ADDRESS = "REGISTEREDADDRESS";
_constant.AGE = "AGE";
_constant.AMOUNT = "Amount";
_constant.CUSTOM = "CUSTOM";
_constant.CUSTOM_TEXT = "Text";
_constant.CUSTOM_NUMBER = "Numeric";
_constant.CUSTOM_DROPDOWN = "Dropdown";
_constant.CUSTOM_DATE = "Date";
_constant.CUSTOM_AMOUNT = "UserAmount";
_constant.CUSTOM_MOBILE_NUMBER = "MobileNumber";
_constant.CUSTOM_AMOUNT = "UserAmount";
_constant.CUSTOM_AMOUNT_MERCHANT = "Amount";
_constant.CUSTOM_AMOUNT_FLEXIBLE = "FlexibleAmount";
_constant.CUSTOM_AMOUNT_QUANTATIVE = "QuantityAmount";
_constant.CUSTOM_AMOUNT_PARTIAL = "PartialAmount";
_constant.CUSTOM_AMOUNT_HIDDEN = "HiddenAmount";
_constant.CUSTOM_AMOUNT_DROPDOWN = "DropdownAmount";
_constant.midlink = "mid";
_constant.merchantName = "merchantName";
_constant.VALIDATION_FIXED = "Fixed Text";
_constant.VALIDATION_SHORT = "Short Text";
_constant.VALIDATION_LONG = "Long Text";
_constant.SHORT_VALLIDATION_MIN_CHAR = 3;
_constant.SHORT_VALLIDATION_MAX_CHAR = 30;
_constant.LONG_VALLIDATION_MIN_CHAR = 3;
_constant.LONG_VALLIDATION_MIN_CHAR = 200;
_constant.LENGTH_VALIDATION_CHAR = "lengthValidationChar";
_constant.FIXED_VALIDATION_CHAR = "fixedValidationChar";
_constant.LENGTH_VALIDATION_NUMBER = "lengthValidationNumber";
_constant.FIXED_VALIDATION_NUMBER = "fixedValidationNumber";
_constant.MANDATORY_VALIDATION = "isMandatoryValidation";
_constant.DATE_VALIDATION = "dateValidation";
_constant.LIST_VALIDATION = "listValidation";
_constant.NUMBER_VALIDATION = "numberValidation";
_constant.TEXT_VALIDATION = "textValidation";
_constant.PIN_VALIDATION = "PINValidation";
_constant.MOBILE_NUMBER_VALIDATION = "mobileNumberValidation";
_constant.EMAIL_VALIDATION = "emailValidation";
_constant.ACTIVE = "ACTIVE";
_constant.INACTIVE = "INIT";
_constant.REJECT = "REJECT";
_constant.EXPIRED = "EXPIRED";
_constant.CLOSED = "CLOSED";
_constant.AUTHORIZATION_FAILED = "AUTHORIZATION_FAILED";
_constant.AUTHORIZED = "AUTHORIZED";
_constant.SUSPENDED = "SUSPENDED";
_constant.SUBS_MIN_AMOUNT = 1;
_constant.ONDEMAND = "ONDEMAND";
_constant.BUTTON_CLICKED = "BUTTON_CLICKED";
_constant.API_FAIL = "API_FAIL";
_constant.API_SUCCESS = "API_SUCCESS";
_constant.LINK_ID = "LINKID";
_constant.YMD_FORMAT = "YYYY/MM/DD";
_constant.DMY_FORMAT = "MM/DD/YYYY";
_constant.POPUP_CLOSED = "POPUP_CLOSED";
_constant.POPUP_OPENED = "POPUP_OPENED";
_constant.POPUP_IN = "POPUP_IN";
_constant.AMOUNT_FIXED = "FIX";
_constant.AMOUNT_VARIABLE = "VARIABLE";
_constant.EMAIL_REG_EX = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
_constant.CANCEL = "CANCEL";
_constant.SUBS_ID = "SUBSCRIPTION_ID";
_constant.CANCEL_SUBSCRIPTION_STATE = "CANCEL_SUBSCRIPTION_STATE";
_constant.RESEND_OTP = "RESEND_OTP";
_constant.FAILED = "FAILED";
_constant.PENDING = "PENDING";
_constant.LINK_NAME = "LINK_NAME";
_constant.LINK_ID_PREFIX = "LL_";
_constant.IS_AOA_FLOW = "IS_AOA_FLOW";

/* ---------------- API URLs -----------------------*/

_constant.LINK = "link";
_constant.BUILD = "build";
_constant.BASE_URL = "";
_constant.PAYMENT_FORM_SUBMIT_URL = "link/form/submitUserForm";
_constant.MOBILE_NUMBER_SUBMIT_URL = "theia/linkPayment/generateSendOTP";
_constant.OTP_SUBMIT_URL = "theia/linkPayment/validateSendOTP";
_constant.EDIT_SUBSCRIPTION = "subscription/v3/panel/edit";
_constant.EDIT_SUBSCRIPTION_AUTH = "subscription/v3/panel/edit/authorize";

_constant.INPUTVALIDATOR = {
  [_constant.LENGTH_VALIDATION_CHAR]: (minLength, maxLength, val) => {
    minLength = minLength || 3;
    maxLength = maxLength || 200;
    const { length } = val.trim();
    if (length > maxLength) {
      return "maxError";
    }
    if (length < minLength) {
      return "minError";
    }
    return true;
  },
  [_constant.LENGTH_VALIDATION_NUMBER]: (minNumber, maxNumber, val) => {
    minNumber = parseInt(maxNumber);
    maxNumber = parseInt(maxNumber);
    val = parseInt(val.trim());
    if (val > maxNumber) {
      return "maxError";
    }
    if (val < minNumber) {
      return "minError";
    }
    return true;
  },
  [_constant.MANDATORY_VALIDATION]: val => {
    val = val.trim();
    if (val !== undefined && val !== null && val !== "") {
      return false;
    }
    return true;
  },
  [_constant.FIXED_VALIDATION_CHAR]: (fixedLength, val) => {
    const { length } = val.trim();
    if (length !== fixedLength) {
      return "fixed";
    }
    return false;
  },
  [_constant.FIXED_VALIDATION_NUMBER]: (fixedValue, val) => {
    val = parseInt(val.trim());
    if (val !== fixedValue) {
      return true;
    }
    return false;
  }
};

export default _constant;



// WEBPACK FOOTER //
// ./utils/constants.js